import React, { useState, useEffect } from 'react';
import { MasterAreaState } from '../models/Master';
import { CheckBoxGroup } from './CheckBoxGroup';
import { FormInstance } from 'antd';

interface props {
    data: MasterAreaState[];
    form: FormInstance<any>;
    isOdd?: boolean;
    getListChild?: (item: MasterAreaState) => void;
    maxLevel: number;
}

export const DividedColumn = ({ data, isOdd, form, getListChild, maxLevel }: props) => {
    const [state, setState] = useState<MasterAreaState[]>([]);

    useEffect(() => {
        const result: MasterAreaState[] = [];
        for (let i = 0; i < data.length; i++) {
            if (isOdd && i % 2 == 0) result.push(data[i]);
            else if (!isOdd && i % 2 == 1) result.push(data[i]);
        }
        setState(result);
    }, [JSON.stringify(data)]);

    return (
        <React.Fragment>
            {state?.map((element) => <CheckBoxGroup form={form} key={element.id} data={element} getListChild={getListChild} maxLevel={maxLevel}/>)}
        </React.Fragment>
    );
};
